import "./HeaderComponent.scss";
import BrandingComponent from "../branding/BrandingComponent";
import MenuComponent from "../menu/MenuComponent";
import ProfileDropdownComponent from "../profile-dropdown/ProfileDropdownComponent";

interface HeaderComponentProps {
    showProfileDropdown?: string;
}

const HeaderComponent = (props: HeaderComponentProps) => {
    const {showProfileDropdown} = props;

    return (
        <div className="header-component">
            <div>
                <BrandingComponent/>
            </div>
            <div>
                <MenuComponent/>
            </div>
            <div>
                {!showProfileDropdown && <ProfileDropdownComponent/>}
            </div>
        </div>
    );

};

export default HeaderComponent;
